export default {
  rollover: {
    title: 'रोलओवर',
    detailsTitle: 'रोलओवर विवरण',
    all: 'सभी',
    allStats: 'सभी स्थितियाँ',
    select: 'चुनें',
    rolloverType: 'रोलओवर प्रकार',
    amount: 'राशि',
    source: 'स्रोत',
    wallet: 'वॉलेट',
    current: 'वर्तमान',
    wagered: 'दांव लगाया गया',
    required: 'आवश्यक',
    progress: 'प्रगति',
    loading: 'लोड हो रहा है...',
    noData: 'कोई डेटा नहीं',
    noMoreData: 'और डेटा नहीं',
    state: 'स्थिति',
    type: 'प्रकार',
    createdOn: 'बनाया गया',
    wageringRequirement: 'दांव की आवश्यकता',
    currency: 'मुद्रा',
    wagerRequired: 'आवश्यक दांव',
    wagerCompleted: 'पूर्ण दांव',
    cash: 'नकद',
    bonus: 'बोनस',
  },
};
